import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import axios from 'axios'
import AddPhoneItem from '@/components/MainFlow/AddSubscriptions/AddPhoneItem'
import AddFamilyPhoneItem from '@/components/MainFlow/AddSubscriptions/AddFamilyPhoneItem'
import AddPowerItem from '@/components/MainFlow/AddSubscriptions/AddPowerItem'
import PhoneItems from '@/components/MainFlow/AddSubscriptions/PhoneItems'
import SummaryFooter from '@/components/MainFlow/SummaryFooter'
import PowerItems from '@/components/MainFlow/AddSubscriptions/PowerItems'

import config from '@/config/config-esm'

import { setFormData } from '@/store/slices/formDataSlice'
import { setAppData } from '@/store/slices/appDataSlice'
import { validateFamily } from '@/lib/family_validation'
import { getOrderPriceBreakdown } from '@/lib/prices'

const AddSubscriptionsComponent = () => {
  const dispatch = useDispatch()
  const formData = useSelector((state) => state.formData)
  const appData = useSelector((state) => state.appData)
  const layout = useSelector((state) => state.layout)
  
  const [referalPhone, setReferalPhone] = useState('')
  const [quickstatReply, setQuickstatReply] = useState(null)
  const [subscriptions, setSubscriptions] = useState([])
  const [powerPlans, setPowerPlans] = useState([])
  const [showAddPhoneModal, setShowAddPhoneModal] = useState(formData.newPhoneSession)
  const [showAddFamilyPhoneModal, setShowAddFamilyPhoneModal] = useState(formData.newFamilyPhoneSession)
  const [showAddPowerModal, setShowAddPowerModal] = useState(formData.newPowerSession)
  const [editIndex, setEditIndex] = useState(null)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const lookupReferalCode = async (ev) => {
    ev.preventDefault()
    const response = await axios.post(`${config.newApiUrl}/rpc/quickstat`, {
      phone_no: referalPhone,
    })
    setQuickstatReply(response.data)
    console.log(response.data)
  }

  const allowNext = () => {
    return (
      formData.phoneItems.length || formData.powerItems.length || validateFamily(formData.family)
    )
    // if (formData.simNumber.length === 12 || formData.simNumber.length == 0) {
    //   return true
    // }
    // return false
  }

  const { departmentId } = layout.data
  const { chatDepartmentIds } = config
  
  return (
    <div>
      {showAddPhoneModal && (
        <div className="fieldsales-overlay">
          <AddPhoneItem 
            editIndex={editIndex} 
            subscriptions={appData.subscriptions}
            onClose={() => setShowAddPhoneModal(false)}
          />
        </div>
      )}
      {showAddFamilyPhoneModal && (
        <div className="fieldsales-overlay">
          <AddFamilyPhoneItem 
            editIndex={editIndex} 
            subscriptions={appData.subscriptions}
            onClose={() => setShowAddFamilyPhoneModal(false)}
          />
        </div>
      )}
      {showAddPowerModal && (
        <div className="fieldsales-overlay">
          <AddPowerItem 
            editIndex={editIndex} 
            powerPlans={appData.powerPlans}
            onClose={() => setShowAddPowerModal(false)}
          />
        </div>
      )}
      <div className="step__main">
        <div className="step__main__inner">
          <PhoneItems 
            subscriptions={appData.subscriptions}
            onAddPhone={() => {
              setShowAddPhoneModal(true)
              setEditIndex(null)
            }}
            onEditPhone={(idx) => {
              setShowAddPhoneModal(true)
              setEditIndex(idx)
            }}
            onAddFamily={() => {
              setShowAddFamilyPhoneModal(true)
              setEditIndex(null)
            }}
            onEditFamily={() => setShowAddFamilyPhoneModal(true)}
          />
          {/*
          <PowerItems 
            powerPlans={appData.powerPlans}
            onAddPower={() => {
              setShowAddPowerModal(true)
              setEditIndex(null)
            }}
            onEditPower={(idx) => {
              setShowAddPowerModal(true)
              setEditIndex(idx)
            }}
          />
          */}
        </div>
      </div>
      {chatDepartmentIds.includes(departmentId) && (
        <div className="power-referal-lookup step__main__inner">
          <div style={{ display: 'flex' }}>
            <div style={{ flex: 1 }}>
              <form onSubmit={lookupReferalCode}>
                <div className="input_wrapper">
                  <label htmlFor="referalPhone">Finn strøm-vervekode for et mobilnummer</label>
                  <input
                    name="referalPhone"
                    placeholder="Mobilnummer"
                    value={referalPhone}
                    onChange={(ev) => setReferalPhone(ev.target.value)}
                  />
                </div>
                <button
                  disabled={!(referalPhone && referalPhone.length === 8)}
                  style={{ marginRight: '1rem' }}
                >
                  Finn vervekode
                </button>
                <a
                  href=""
                  onClick={(ev) => {
                    ev.preventDefault()
                    setReferalPhone('')
                    setQuickstatReply(null)
                  }}
                >
                  Nullstill
                </a>
              </form>
            </div>
            <div className="referal-reply">
              {Boolean(!quickstatReply) && (
                <div className="placeholder">Svaret kommer her...</div>
              )}
              {Boolean(quickstatReply) && (
                <React.Fragment>
                  {Boolean(
                    quickstatReply.electricity &&
                      quickstatReply.electricity.customerNumber,
                  ) && (
                    <div className="success">
                      VERV{quickstatReply.electricity.customerNumber}
                    </div>
                  )}
                  {Boolean(
                    !(
                      quickstatReply.electricity &&
                      quickstatReply.electricity.customerNumber
                    ),
                  ) && <div className="not-found">Kunden er ikke strømkunde hos Talkmore.</div>}
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      )}
      {config.showingDebugInfo && config.debugSize !== 'minimized' && (
        <div className="debug_element">
          <h2>Price breakdown</h2>
          <pre>{JSON.stringify(getOrderPriceBreakdown(appData, formData), null, 2)}</pre>
        </div>
      )}
      <div className="step__footer_wrapper">
        <div className="step__footer">
          <button
            className="next"
            onClick={(e) => dispatch(setFormData({ step: 'sign-submit' }))}
            disabled={!allowNext()}
          >
            Videre til vilkår og innsending
          </button>
        </div>
      </div>
    </div>
  )
}

export default AddSubscriptionsComponent
